import { render } from "./manualExtension.vue?vue&type=template&id=ee06c1d6&scoped=true"
import script from "./manualExtension.vue?vue&type=script&lang=js"
export * from "./manualExtension.vue?vue&type=script&lang=js"

import "./manualExtension.vue?vue&type=style&index=0&id=ee06c1d6&lang=scss&scoped=true"
import "./manualExtension.vue?vue&type=style&index=1&id=ee06c1d6&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee06c1d6"]])

export default __exports__